import { GearSix } from "@phosphor-icons/react";
import { useEffect } from "react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import Label from "common/components/ui/Label";
import RadioButton from "common/components/ui/RadioButton";

// Options for the settings popover
const options = [
  {
    id: "enter-send",
    isEnabled: false,
    label: "Enter to Send",
    description: "Ctrl + Enter to add a new line",
  },
  {
    id: "enter-new-line",
    isEnabled: true,
    label: "Enter to add a new line",
    description: "Ctrl + Enter will send a message",
  },
];

interface SettingsPopupProps {
  ctrlToSend: boolean;
  setCtrlToSend: (ctrlToSend: boolean) => void;
  isDisabled: boolean;
}

export default function SettingsPopup({
  ctrlToSend,
  setCtrlToSend,
  isDisabled,
}: SettingsPopupProps) {
  useEffect(() => {
    localStorage.setItem("ctrlToSend", ctrlToSend.toString());
  }, [ctrlToSend]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={isDisabled}>
        <Button
          intent="iconOnly"
          variant="ghost-black"
          size="xs"
          className="data-[state=open]:bg-black-100"
        >
          <GearSix />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuList>
          {options.map(({ id, isEnabled, label, description }) => (
            <DropdownMenuItem
              key={id}
              className="flex items-start space-x-2"
              onClick={() => setCtrlToSend(isEnabled)}
            >
              <RadioButton
                className="mt-0.5"
                checked={ctrlToSend === isEnabled}
                id={id}
              />

              <Label htmlFor={id} className="flex flex-col items-start gap-0.5">
                <span className="text-button-sm">{label}</span>

                <span className="text-xs text-black-400">{description}</span>
              </Label>
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
